import type { LiveSession } from "components/Editor/useEditorStore/live-session/queries";
import type { State } from "features/editor/types";
import React from "react";

import { EditorPageContent } from "components/EditorPageContent";
import { EditorRouterProvider } from "hooks/useEditorRouter";

export default function Editor({
  liveSession,
  initialState,
}: {
  initialState?: State;
  liveSession?: LiveSession;
}) {
  return (
    <EditorRouterProvider>
      <EditorPageContent
        initialState={initialState}
        liveSession={liveSession}
      />
    </EditorRouterProvider>
  );
}
